import {
  Box,
  Grid,
  Typography,
  Toolbar,
} from '@mui/material'
// import { Toolbar } from '@mui/x-data-grid-premium'
import React, { useEffect, useMemo, useState } from 'react'
import { NewDeal, User } from 'types'
import MultiUserSelect from 'components/Forms/MultiUserSelect'
import { useUserItems } from 'api/aws/users/useUserItems'
import { renderColorByString } from '../renderColorByString'
import { toIdArray } from 'utils/toIdArray'
import SaveNewOnboardingTeam from 'components/ui/save-new-onboarding-team'
import AssigneeAvatars from './AssigneeAvatars'

interface ToolbarProps {
  deal: NewDeal
  onUpdate: (fieldName: string, newValue: any) => Promise<void>
  checklistType: string
  isOwner?: boolean
  isPM?: boolean
}
const idsEqual = (a: User[] | undefined, b: User[] | undefined) => {
  const aa = (a ?? [])
    .map(u => u?.user_uuid)
    .filter(Boolean)
    .sort()
  const bb = (b ?? [])
    .map(u => u?.user_uuid)
    .filter(Boolean)
    .sort()
  if (aa.length !== bb.length) return false
  for (let i = 0; i < aa.length; i++) if (aa[i] !== bb[i]) return false
  return true
}

const DrawerTasksToolbar: React.FC<ToolbarProps> = ({ deal, onUpdate, checklistType, isPM }) => {
  const roles = ['AM', 'PM', 'DMS', 'SEO', 'QA', 'BD', 'MIA', 'Integration']
  const { data: users, isLoading: isUsersLoading } = useUserItems()
  const [localOnboardingTeam, setLocalOnboardingTeam] = useState<User[] | undefined>(undefined)
  const [saving, setSaving] = useState(false)
  const onboardingTeam: User[] = useMemo(() => {
    if (!users || isUsersLoading) return []
    const ids = toIdArray(deal?.onboardingTeamIds) // <-- robust
    if (!ids.length) return []
    const byId = new Map(users.map(u => [u.user_uuid, u]))
    return ids.map(id => byId.get(id)).filter(Boolean) as User[]
  }, [users, isUsersLoading, deal?.onboardingTeamIds])

  // seed local state once when upstream team is ready
  useEffect(() => {
    if (localOnboardingTeam === undefined) {
      setLocalOnboardingTeam(onboardingTeam)
    }
  }, [onboardingTeam, localOnboardingTeam])
  const dirty = !idsEqual(localOnboardingTeam, onboardingTeam)

  const handleSave = async () => {
    if (!localOnboardingTeam) return
    setSaving(true)
    try {
      const newIds = (localOnboardingTeam ?? []).map(u => u.user_uuid).filter(Boolean)
      await onUpdate('onboardingTeamIds', newIds)
    } finally {
      setSaving(false)
    }
  }
  return (
    <Toolbar disableGutters sx={{ px: 0.5 }}>
      <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={4.8}
          xl={12}
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
        >
          {isPM && (
            <MultiUserSelect
              name="onboardingTeam"
              value={localOnboardingTeam ?? onboardingTeam ?? []}
              options={users ?? []}
              displayLabel="Onboarding Team"
              onChange={newUsers => setLocalOnboardingTeam(newUsers)}
              singleSelect={false}
              isGridUpdate={false}
              max={8}
            />
          )}

          {(localOnboardingTeam || onboardingTeam) && !isPM && (
            <AssigneeAvatars
              assignees={localOnboardingTeam ?? onboardingTeam ?? []}
              max={6}
              sizes={{ height: 36, width: 36 }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={1} xl={12}>
          {/* {!isEqual(localOnboardingTeam, onboardingTeam || []) && (
            <Tooltip
              title={
                !isEqual(localOnboardingTeam, onboardingTeam || []) ? (
                  <Typography>Save Assignees</Typography>
                ) : (
                  <Typography>Up to date</Typography>
                )
              }
            >
              <IconButton
                onClick={handleSave}
                className={
                  !isEqual(localOnboardingTeam, onboardingTeam || []) ? 'highlight-assignee-save' : 'assignee-save-hide'
                }
              >
                <SaveIcon
                  className={
                    !isEqual(localOnboardingTeam, onboardingTeam || [])
                      ? 'highlight-assignee-save'
                      : 'assignee-save-hide'
                  }
                  sx={{
                    fontSize: 28,
                    color: !isEqual(localOnboardingTeam, onboardingTeam || []) ? 'text.highlight' : 'text.secondary',
                  }}
                />
              </IconButton>
            </Tooltip>
          )} */}
          <SaveNewOnboardingTeam newTeam={localOnboardingTeam} currTeam={onboardingTeam} onSave={handleSave} />
        </Grid>

        {/* </Box> */}
        <Grid item xs={12} sm={12} md={12} lg={5.2} xl={12}>
          <Box display={'flex'} justifyContent="flex-end" width={'100%'}>
            <Typography variant="h6" sx={{ color: renderColorByString(checklistType) }}>
              {checklistType}
            </Typography>
          </Box>
        </Grid>

        {/* <Grid item xs={12} sm={12} md={12} lg={5.2} xl={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <IconButton onClick={onAddRow}>
              <SimpleCustomTooltip title="Add New Task" isLoading={isDisabled}>
                <AddTaskIcon sx={{ fontSize: '30px' }} />
              </SimpleCustomTooltip>
            </IconButton>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={1} xl={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <IconButton onClick={() => setConfirmOpen(true)} disabled={isDeleting}>
              <SimpleCustomTooltip title="Delete Current Task List" isLoading={isDisabled} textColor={'text.error'}>
                <DeleteOutlineIcon sx={{ height: 22, width: 22, color: 'text.error' }} />
              </SimpleCustomTooltip>
            </IconButton>
          </Box>
        </Grid> */}
      </Grid>
    </Toolbar>
  )
}

export default DrawerTasksToolbar
